import React, { FunctionComponent, useState } from "react";
import {
  AddSchoolRequest,
  School,
} from "../../../../../store/onboarding/types";
import { toastr } from "react-redux-toastr";
import {
  Alert,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  Spinner,
} from "react-bootstrap";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  addSchool,
  hideUpsertSchoolModal,
  updateSchool,
} from "../../../../../store/onboarding/actions";
import { connect, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

type PropsFromState = {
  // teachers: Array<TeacherInfo>;
  showModal: boolean;
  selectedSchool?: School | string;
  //newSchoolForCreatable?: string;
  callback?: Function;
  isLoading: {
    addSchool: boolean;
    updateSchool: boolean;
    getTeachers: boolean;
  };
};

type DispatchProps = {
  hideUpsertSchoolModal: () => any;
  addSchool: (school: AddSchoolRequest, districtId?: number) => any;
  updateSchool: (school: School) => any;
};

type Props = PropsFromState & DispatchProps;

const UpsertSchoolModal: FunctionComponent<Props> = ({
  showModal,
  isLoading,
  selectedSchool,
  //newSchoolForCreatable,
  updateSchool,
  addSchool,
  hideUpsertSchoolModal,
  callback,
}) => {
  const [schoolName, setSchoolName] = useState("");
  // const [schoolType, setSchoolType] = useState<
  //   ReactSelectOption<any> | undefined
  // >(undefined);
  // const [startDate, setStartDate] = useState<Date | null>(null);
  // const [endDate, setEndDate] = useState<Date | null>(null);
  // const [faculty, setFaculty] = useState<Array<UserInfo>>([]);

  // const schoolsOptions = useMemo(
  //   () =>
  //     Object.entries(SchoolTypesDisplayedNames).map(([key, value]) => ({
  //       value: key,
  //       label: value
  //     })),
  //   []
  // );

  const handleShowModal = () => {
    if (selectedSchool) {
      if(typeof selectedSchool === 'object' && selectedSchool !== null) { //create from teacher invite
        setSchoolName(selectedSchool.name);
      } else {
         setSchoolName(selectedSchool);
      }
      // setSchoolType(
      //   schoolsOptions.find(so => +so.value === selectedSchool.school_type)
      // );
      // setStartDate(
      //   selectedSchool.current_year?.start_date
      //     ? moment.utc(selectedSchool.current_year.start_date).toDate()
      //     : null
      // );
      // setEndDate(
      //   selectedSchool.current_year?.end_date
      //     ? moment.utc(selectedSchool.current_year?.end_date).toDate()
      //     : null
      // );
      // setFaculty(selectedSchool.faculty);
    } else {
      setSchoolName("");
      // setSchoolType(undefined);
      // setStartDate(null);
      // setEndDate(null);
      // setFaculty([]);
    }
  };

  const districtId = useSelector<ApplicationState, number | undefined>(
    (s) => s.onboarding.modalsState.upsertSchoolModalConfig?.districtId
  );

  const handleSubmit = (event: React.FormEvent<any>) => {
    event.preventDefault();
    if (!isLoading.addSchool && !isLoading.updateSchool) {
      if (selectedSchool && (typeof selectedSchool === 'object' && selectedSchool !== null) && !callback) {
        updateSchool({
          ...selectedSchool,
          name: schoolName,
        }).then(
          () => hideUpsertSchoolModal(),
          (err: string) => toastr.error("Failed to update the school", err)
        );
      } else {
        addSchool({
          name: schoolName,
          district: districtId,
        }).then(
          (newSchool: School) => {
            if (callback) {
              callback(newSchool);
            }
            hideUpsertSchoolModal()
          },
          (err: string) => toastr.error("Failed", err)
        );
      }
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={hideUpsertSchoolModal}
      onShow={handleShowModal}
      centered
      animation={false}
      backdropClassName="customDarkModalBackdrop in"
    >
      <Modal.Header closeButton className="purpleModalHeader font-weight-bold">
        <Modal.Title>
          {(typeof selectedSchool === 'object' && selectedSchool !== null) ? "Edit School" : "Add School"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <Alert variant="warning">
            The school name {(typeof selectedSchool === 'object' && selectedSchool !== null) ? "edited " : "created "} 
            here must exactly match the school name used in your district’s data uploads; 
            otherwise, the system will treat them as separate schools.
          </Alert>
        <Form onSubmit={handleSubmit}>
          <FormGroup controlId="name">
            <Form.Label className="font-weight-bold text-left">
              <FormattedMessage id="app.forms.schoolName.label" />
            </Form.Label>
            <span className="label-asterisk">*</span>
            <FormControl
              autoFocus
              className="fullWidthInput"
              name={"name"}
              type="text"
              value={schoolName}
              onChange={(e: any) =>
                setSchoolName((e.target as HTMLInputElement).value)
              }
              required
            />
          </FormGroup>

          {/*<h4>School Type</h4>*/}
          {/*<Select*/}
          {/*  placeholder={"Select..."}*/}
          {/*  isClearable*/}
          {/*  value={schoolType}*/}
          {/*  options={schoolsOptions}*/}
          {/*  onChange={(schoolOption: any) => {*/}
          {/*    setSchoolType(schoolOption);*/}
          {/*  }}*/}
          {/*/>*/}

          {/*<h4 className="mt-3">Start of the Year</h4>*/}
          {/*<DatePicker*/}
          {/*  customInput={<CustomDateInput />}*/}
          {/*  maxDate={endDate ?? null}*/}
          {/*  selected={startDate}*/}
          {/*  onChange={date => setStartDate(date)}*/}
          {/*/>*/}

          {/*<h4 className="mt-3">End of the Year</h4>*/}
          {/*<DatePicker*/}
          {/*  customInput={<CustomDateInput />}*/}
          {/*  minDate={startDate ?? null}*/}
          {/*  selected={endDate}*/}
          {/*  onChange={date => setEndDate(date)}*/}
          {/*/>*/}

          {/*<h4 className="mt-3">Faculty</h4>*/}
          {/*<Select*/}
          {/*  isMulti*/}
          {/*  isClearable*/}
          {/*  isLoading={isLoading.getTeachers}*/}
          {/*  placeholder={"Select..."}*/}
          {/*  value={faculty}*/}
          {/*  options={teachers.map((t: TeacherInfo) => t.user)}*/}
          {/*  getOptionValue={teacher => teacher.id.toString()}*/}
          {/*  getOptionLabel={teacher => getFullName(teacher)}*/}
          {/*  onChange={(faculty: any) => {*/}
          {/*    setFaculty(faculty ?? []);*/}
          {/*  }}*/}
          {/*/>*/}

          <div className="btnActions">
            <button
              type="reset"
              className="whiteBtnSm"
              disabled={isLoading.addSchool || isLoading.updateSchool}
              onClick={hideUpsertSchoolModal}
            >
              Cancel
            </button>
            <button className="blueBtnSm" type="submit" disabled={!schoolName}>
              {(typeof selectedSchool === 'object' && selectedSchool !== null) ? "Update " : "Add "}
              {(isLoading.addSchool || isLoading.updateSchool) && (
                <Spinner animation="border" size="sm" />
              )}
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = ({ onboarding }: ApplicationState): PropsFromState => {
  return {
    // teachers: onboarding.teachersRoster,
    showModal: onboarding.modalsState.upsertSchoolModal,
    selectedSchool: onboarding.selectedSchool,
    //newSchoolForCreatable: onboarding.newSchoolForCreatable,
    callback: onboarding.modalsState.schoolCreateModalCallback,
    isLoading: {
      addSchool: onboarding.isLoading.addSchool,
      updateSchool: onboarding.isLoading.updateSchool,
      getTeachers: onboarding.isLoading.getTeachers,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      hideUpsertSchoolModal: hideUpsertSchoolModal,
      addSchool: addSchool,
      updateSchool: updateSchool,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UpsertSchoolModal);
